import useCancellablePromises from "./useCancellablePromise";
import { cancellablePromise } from "./CancellablePromise";
const useClickPreventionOnDoubleClick = (onClick, onDoubleClick) => {
  const api = useCancellablePromises();

  const delay = (n) => new Promise((resolve) => setTimeout(resolve, n));
  const handleClick = (e) => {
    api.clearPendingPromises();
    const waitForClick = cancellablePromise(delay(300));
    api.appendPendingPromise(waitForClick);

    return waitForClick.promise
      .then(() => {
        api.removePendingPromise(waitForClick);

        onClick(e);
      })
      .catch((errorInfo) => {
        api.removePendingPromise(waitForClick);
        if (!errorInfo.isCanceled) {
          if (errorInfo.error) throw errorInfo.error;
        }
      });
  };

  const handleDoubleClick = (e) => {
    api.clearPendingPromises();
    onDoubleClick(e);
  };

  return [handleClick, handleDoubleClick];
};

export default useClickPreventionOnDoubleClick;
